import { io } from "socket.io-client";

const URL =
  process.env.API_REALTIME ||
  "https://tickets-realtime-production-b238.up.railway.app/sgdinner";
// const URL = "https://tickets-realtime-production.up.railway.app/sgdinner" //api-sgdinner-railway-test
// const URL = "http://localhost:6969/sgdinner";

// Configuración para reconexión automática
const socketConfig = {
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 10000,
  randomizationFactor: 0.5,
  auth: {
    token: localStorage.getItem("accessTokenAdm"),
  },
};

export const socket = io(URL, socketConfig);

// Manejo de eventos de conexión/desconexión
socket.on("connect", () => {
  console.log("Socket conectado");
  // Reunirse a las salas necesarias
  socket.emit("join:ticket", "ticketsEmitidos");
  socket.emit("join:ticket", "ticketPeriodos");
});

socket.on("connect_error", (error) => {
  console.error("Error de conexión:", error);
});

socket.on("disconnect", (reason) => {
  console.log("Socket desconectado:", reason);
  // Intentar reconectar automáticamente
  socket.connect();
});

// Manejo de cambios en la conexión de internet
window.addEventListener("online", () => {
  if (!socket.connected) {
    console.log("Internet restaurado, intentando reconectar...");
    socket.connect();
  }
});

window.addEventListener("offline", () => {
  console.log("Internet desconectado");
});
